define('formkit/view/form.object/common/answer.form.object.top.view',['require','exports','module','underscore','./base.form.object.top.view','marionette','../../../templates','../../../behavior/tooltip.behavior','uikit/uikit'],function(require, exports, module) {
  var _                     = require('underscore');
  var BaseFormObjectTopView = require('./base.form.object.top.view');
  var Mn                    = require('marionette');
  var Templates             = require('../../../templates');
  var TooltipBehavior       = require('../../../behavior/tooltip.behavior');
  var UIKit                 = require('uikit/uikit');

  var IndicatorView = UIKit.ItemView.extend({
    template: function() {
      return '<ui name="helpTextView" /><ui name="failedValidationsButtonView" />'
    },

    internalViewOptions: {
      helpTextView: function() {
        return {
          type: UIKit.Button,
          circular: true,
          icon: 'help circle',
          model: this.model,
          behaviors: {
            TooltipBehavior: {
              html: '<div class="wrap-text">' + this.model.get('helpText') + '</div>',
              position: 'top center',
              variant: 'inverted',
              className: {
                popup: 'ui popup visible very wide'
              },
              behaviorClass: TooltipBehavior
            }
          }
        }
      },
      failedValidationsButtonView: function() {
        return {
          type: UIKit.Button,
          circular: true,
          color: 'red',
          icon: 'warning',
          model: this.getOption('formObjectState'),
          bindings: {
            visible: 'hasFailedValidations'
          },
          visible: false,
          onPress: function() {
            this.model.showAllFailedValidations()
          }
        }
      }
    },

    initialize: function() {
      UIKit.ItemView.prototype.initialize.apply(this, arguments);
      this.formObjectState = this.getOption('formObjectState');
      this.helpTextView.visible = (this.model.get('helpText') && this.model.get('helpText').length) ? true : false;
    }
  });

  var ActionsView = UIKit.ItemView.extend({
    template: function() { return '<ui name="commentButtonView" /> <ui name="issuesButtonView" />' },

    internalViewOptions: {
      commentButtonView: {
        type: UIKit.Button,
        circular: true,
        disabled: true,
        icon: 'comment'
      },
      issuesButtonView: {
        type: UIKit.Button,
        circular: true,
        disabled: true,
        icon: 'warning sign'
      }
    }
  })

  var AnswerFormObjectTopView = BaseFormObjectTopView.extend({
    internalViewOptions: BaseFormObjectTopView.extendInternalViewOptions({
      indicatorView: function() {
        return {
          type: IndicatorView,
          model: this.model,
          formObjectState: this.getOption('formObjectState')
        }
      },

      actionsView: function() {
        return _.extend({
          type: ActionsView,
        }, Mn._getValue(this.getOption('actions'), this), {});
      }
    })
  });

  module.exports = AnswerFormObjectTopView;
});

